"use client";

import { Core } from "@faire/slate/foundation/color";
import { iconCls } from "@faire/slate/lib/tracking";
import React from "react";

import { createSVGIcon } from "../lib/iconUtils";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1683))
 * @trackcomponent
 * @lastsynced 2025-07-08T18:36:40.634Z
 * @optimized using svgo:^3.0.2
 */
export const Block = createSVGIcon(
  <path
    d="M.857 12a11.143 11.143 0 1 0 22.286 0A11.143 11.143 0 0 0 .857 12ZM4.121 19.879 19.88 4.12"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,

  "Block",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      id: "NZ9mzg",
      defaultMessage: "Block",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    color: Core.icon.primary,
    className: iconCls(),
  })
);
